import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { Capacitor } from '@capacitor/core'

export default function ProtectedRoute({ children, role }) {
  const { user, profile, subscription, loading, isSubscriptionActive } = useAuth()

  if (loading) return (
    <div style={{ minHeight: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)' }}>
      <p style={{ color: 'var(--text-tertiary)' }}>Loading...</p>
    </div>
  )

  if (!user) return <Navigate to="/login" />
  if (role && profile?.role !== role) return <Navigate to="/login" />

  // Wait for subscription to load before gating clinicians
  if (role === 'clinician' && profile && subscription === null) return (
    <div style={{ minHeight: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg)' }}>
      <p style={{ color: 'var(--text-tertiary)' }}>Loading...</p>
    </div>
  )

  if (role === 'clinician' && !isSubscriptionActive()) {
    if (Capacitor.isNativePlatform()) {
      return (
        <div style={{ minHeight: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem', textAlign: 'center', background: 'var(--bg)' }}>
          <div style={{ fontSize: 48, marginBottom: '1rem' }}>⏸️</div>
          <h1 style={{ fontSize: 20, marginBottom: 8 }}>Subscription inactive</h1>
          <p style={{ color: 'var(--text-secondary)', maxWidth: 280, lineHeight: 1.6 }}>
            To manage your subscription, visit <strong>completept.app</strong> in your browser.
          </p>
        </div>
      )
    }
    return <Navigate to="/billing" />
  }

  return children
}